const statusEnumValues = ['available', 'doubtful', 'injured', 'suspended', 'loan', 'unavailable']

export default statusEnumValues
